// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header.header-page-payment-success .logo-container {
  justify-content: center;
}

.page-payment-success {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 500px;
}

.page-payment-success .success-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
  padding: 0;
  margin: 0 auto;
  margin-top: 32px;
  text-align: center;
}

.page-payment-success .loading-title {
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  margin-top: 32px;
}

.page-payment-success .manual-steps-title {
  margin: 16px 0 24px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}

.page-payment-success .steps-container {
  max-width: 450px;
}

.page-payment-success .steps-container a {
  color: var(--main-highlight-color);
  text-decoration: underline;
}

.page-payment-success .manual-step {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.page-payment-success .manual-step .step-icon {
  --step-icon-size: 22px;
  position: relative;
  margin-right: 12px;

  display: flex;
  justify-content: center;
  align-items: center;

  height: var(--step-icon-size);
  width: var(--step-icon-size);
  min-width: var(--step-icon-size);
  background-color: #aeaeb4;
  border-radius: 50%;
}

.page-payment-success .manual-step .step-icon svg {
  position: absolute;
  top: 0;
  left: 0;
  height: var(--step-icon-size);
  width: var(--step-icon-size);
}

.page-payment-success .manual-step .step-number {
  color: white;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  padding-top: 2px;
}

.page-payment-success .manual-step .text {
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}

.page-payment-success .button-container {
  width: 280px;
  margin-top: 30px;
  height: 50px;
}

.page-payment-success .buttons-container {
  margin-top: 30px;
  display: flex;
  gap: 32px;
}

.page-payment-success .description-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 12px;
  margin-top: 10px;
  position: relative;
}

.page-payment-success .input-like {
  padding: 8px 14px;
  border: 1px solid var(--gray);
  border-radius: 10px;

  font-weight: 500;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: -0.336px;
  flex: 1;
  max-width: 450px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.page-payment-success .copy-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;

  width: fit-content;
  min-width: 65px;
  max-width: 95px;
  padding: 0 14px;
  height: 41px;

  background: var(--gray);
  border-radius: 10px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: -0.036px;
  color: white;
}

.page-payment-success .copy-tooltip {
  min-width: 260px;
  background-color: rgba(85, 85, 85, 0.9);
  color: white;
  text-align: center;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  right: 0;
  padding: 8px;
}

.page-payment-success .copy-tooltip:after {
  content: '';
  position: absolute;
  bottom: -15px;
  right: 28px;
  margin-left: -5px;
  border-width: 8px;
  border-style: solid;
  border-color: rgba(85, 85, 85, 0.9) transparent transparent transparent;
}

.page-payment-success .manual-steps-screenshots {
  --floating-container-border-radius: 30px;
  margin-top: 32px;
  padding: 24px 24px;

  background: var(--light-orange);
  backdrop-filter: blur(14.014598846435547px);

  display: flex;
  justify-content: space-around;
  max-width: 540px;
  --floating-container-width: 100%;
  --floating-container-border: 1px;
  border: var(--floating-container-border) solid rgba(255, 255, 255, 0.28);
  border-radius: var(--floating-container-border-radius);
  width: var(--floating-container-width);
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .page-payment-success .manual-steps-screenshots {
    --floating-container-border-radius: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: var(--page-side-padding-768);
    padding-right: var(--page-side-padding-768);
    width: calc(100% + var(--page-side-padding-768) * 2);
  }
}

.page-payment-success .manual-steps-screenshots img {
  width: calc((100% - 20px) / 2);
  min-width: 130px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/payment-success.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,6BAA6B;EAC7B,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;EACf,YAAY;;EAEZ,uBAAuB;EACvB,mBAAmB;;EAEnB,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;;EAElB,+BAA+B;EAC/B,2CAA2C;;EAE3C,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,wEAAwE;EACxE,sDAAsD;EACtD,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,0CAA0C;IAC1C,2CAA2C;IAC3C,oDAAoD;EACtD;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB","sourcesContent":["#header.header-page-payment-success .logo-container {\n  justify-content: center;\n}\n\n.page-payment-success {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  max-width: 500px;\n}\n\n.page-payment-success .success-title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 130%;\n  padding: 0;\n  margin: 0 auto;\n  margin-top: 32px;\n  text-align: center;\n}\n\n.page-payment-success .loading-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n  margin-top: 32px;\n}\n\n.page-payment-success .manual-steps-title {\n  margin: 16px 0 24px 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n}\n\n.page-payment-success .steps-container {\n  max-width: 450px;\n}\n\n.page-payment-success .steps-container a {\n  color: var(--main-highlight-color);\n  text-decoration: underline;\n}\n\n.page-payment-success .manual-step {\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.page-payment-success .manual-step .step-icon {\n  --step-icon-size: 22px;\n  position: relative;\n  margin-right: 12px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: var(--step-icon-size);\n  width: var(--step-icon-size);\n  min-width: var(--step-icon-size);\n  background-color: #aeaeb4;\n  border-radius: 50%;\n}\n\n.page-payment-success .manual-step .step-icon svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: var(--step-icon-size);\n  width: var(--step-icon-size);\n}\n\n.page-payment-success .manual-step .step-number {\n  color: white;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 12px;\n  padding-top: 2px;\n}\n\n.page-payment-success .manual-step .text {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.page-payment-success .button-container {\n  width: 280px;\n  margin-top: 30px;\n  height: 50px;\n}\n\n.page-payment-success .buttons-container {\n  margin-top: 30px;\n  display: flex;\n  gap: 32px;\n}\n\n.page-payment-success .description-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 12px;\n  margin-top: 10px;\n  position: relative;\n}\n\n.page-payment-success .input-like {\n  padding: 8px 14px;\n  border: 1px solid var(--gray);\n  border-radius: 10px;\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 25px;\n  letter-spacing: -0.336px;\n  flex: 1;\n  max-width: 450px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.page-payment-success .copy-button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n\n  width: fit-content;\n  min-width: 65px;\n  max-width: 95px;\n  padding: 0 14px;\n  height: 41px;\n\n  background: var(--gray);\n  border-radius: 10px;\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 25px;\n  letter-spacing: -0.036px;\n  color: white;\n}\n\n.page-payment-success .copy-tooltip {\n  min-width: 260px;\n  background-color: rgba(85, 85, 85, 0.9);\n  color: white;\n  text-align: center;\n  border-radius: 6px;\n  position: absolute;\n  z-index: 1;\n  bottom: 150%;\n  right: 0;\n  padding: 8px;\n}\n\n.page-payment-success .copy-tooltip:after {\n  content: '';\n  position: absolute;\n  bottom: -15px;\n  right: 28px;\n  margin-left: -5px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: rgba(85, 85, 85, 0.9) transparent transparent transparent;\n}\n\n.page-payment-success .manual-steps-screenshots {\n  --floating-container-border-radius: 30px;\n  margin-top: 32px;\n  padding: 24px 24px;\n\n  background: var(--light-orange);\n  backdrop-filter: blur(14.014598846435547px);\n\n  display: flex;\n  justify-content: space-around;\n  max-width: 540px;\n  --floating-container-width: 100%;\n  --floating-container-border: 1px;\n  border: var(--floating-container-border) solid rgba(255, 255, 255, 0.28);\n  border-radius: var(--floating-container-border-radius);\n  width: var(--floating-container-width);\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .page-payment-success .manual-steps-screenshots {\n    --floating-container-border-radius: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: var(--page-side-padding-768);\n    padding-right: var(--page-side-padding-768);\n    width: calc(100% + var(--page-side-padding-768) * 2);\n  }\n}\n\n.page-payment-success .manual-steps-screenshots img {\n  width: calc((100% - 20px) / 2);\n  min-width: 130px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
